
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7110/api/',

    //Live

    //DEV
    apiUrl: 'https://eskay-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

